import { render, staticRenderFns } from "./gallerySelector.vue?vue&type=template&id=f52ac240&scoped=true&"
import script from "./gallerySelector.vue?vue&type=script&lang=js&"
export * from "./gallerySelector.vue?vue&type=script&lang=js&"
import style0 from "./gallerySelector.vue?vue&type=style&index=0&id=f52ac240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52ac240",
  null
  
)

export default component.exports